import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fromJS, List } from "immutable";
import { createSelector } from "reselect";
export function errorsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case "ERRORS/GLOBAL_ERROR_RECEIVED":
      {
        var serverErrors = state !== null && state !== void 0 && state.serverErrors ? _toConsumableArray(state.serverErrors) : [];
        serverErrors.push(action.payload.error);
        var result = _objectSpread(_objectSpread({}, state), {}, {
          serverErrors: serverErrors
        });
        return result;
      }
    // state.update("serverErrors", List(), errors => errors.push(fromJS(action.payload.error)));

    case "ERRORS/ERROR_DISMISSED":
      {
        var currentErrors = state !== null && state !== void 0 && state.serverErrors ? _toConsumableArray(state.serverErrors) : [];
        if (currentErrors !== undefined && currentErrors.length > 0) {
          currentErrors.shift(); // delete the first value
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          serverErrors: currentErrors,
          errorWaitTimePending: true
        });
        // state
        //   .update("serverErrors", List(), errors => errors.delete(0))
        //   .set("errorWaitTimePending", true);
      }
    case "ERRORS/WAIT_TIME_ELAPSED":
      return _objectSpread(_objectSpread({}, state), {}, {
        errorWaitTimePending: false
      });
    //state.set("errorWaitTimePending", false);

    default:
      return state;
  }
}
var getServerErrors = function getServerErrors(state) {
  var _state$errors;
  return state === null || state === void 0 || (_state$errors = state.errors) === null || _state$errors === void 0 ? void 0 : _state$errors.serverErrors;
};
var getErrorWaitTimePending = function getErrorWaitTimePending(state) {
  var _state$errors2;
  return state === null || state === void 0 || (_state$errors2 = state.errors) === null || _state$errors2 === void 0 ? void 0 : _state$errors2.errorWaitTimePending;
};
var getCurrentError = createSelector([getServerErrors, getErrorWaitTimePending], function (serverErrors, errorWaitTimePending) {
  if (errorWaitTimePending) {
    return undefined;
  } else {
    return serverErrors ? fromJS(serverErrors).first() : List().first();
  }
});
export var errorMessage = createSelector([getCurrentError], function (currentError) {
  var result = currentError ? currentError.get("displayMessage") : undefined;
  return result;
});